const dealers = {
  dealers: 'Installateurs',
  new_dealer: 'Nouvel installateur',
  add_emp: 'Nouvel employé',
  edit_emp: 'Employé',
  search_dealers: 'Rechercher un installateur',
  search_employee: 'Rechercher un employé',
  delete_dealers_message: 'Etes-vous sûr que vous voulez supprimer',
  confirm_modal_confirm: 'Oui, supprimer',
  update_dealer: 'Installateur',
  dealer_info: "Informations sur l'installateur",
  all: 'Tous',
  active: 'Actif',
  inactive: 'Inactif',
  submit: 'Soumettre',
  update: 'Mise à jour',
  edit: 'Modifier',
  organizations: 'Comptes',
  controllers: 'Contrôleurs',
  emp_role: 'Rôle de employé',
  select_dealer_msg: 'Accédez à Installateurs et en sélectionner un',
  confirm_action: 'Etes-vous sûr de vouloir poursuivre cette action ?',
  card_enrollment: 'Enregistrement des identifiants',
  card_information: "Informations de l'identifiant",
  how_you_discover: 'Comment avez-vous découvert CDVI Cloud',
  dealer_registration: "Inscription de l'installateur",
  table: {
    company: 'ENTREPRISE',
    full_name: 'NOM ET PRÉNOM',
    email: 'COURRIEL',
    country: 'PAYS',
    last_login: 'DERNIÈRE CONNEXION',
    active: 'ACTIF',
  },
  form: {
    logo: 'Logo',
    website: 'Site Web',
    mobile: 'Mobile',
    language: 'Langue de communication',
  },
  error: {
    invalid_email: 'Format de courriel invalide',
    invalid_zip: 'Code postal invalide',
  },
  preregistration_success:
    "Nous vous avons envoyé un lien pour compléter l'inscription à votre adresse courriel",
  preregistration_error:
    'Impossible de compléter votre demande. Veuillez réessayer plus tard.',
  request: {
    back_to_home: "Retour à l'accueil",
    error: 'Une erreur est survenue.',
    msg1: 'Nous avons reçu votre demande pour devenir installateur.',
    msg2: 'Nous vous contacterons bientôt par courriel !',
    thank_you: 'Merci {{ companyName }} !',
  },
  tabs: {
    employees: 'Employés',
    payment_methods: 'Méthodes de paiement',
  },
  resend_invitation: "Renvoyer l'invitation",
  status_changed_successfully: 'Statut modifié avec succès',
  dealer_user: {
    no_associated_account:
      'Aucun compte associé, demandez à votre installateur de vous en attribuer un.',
  },
};

export default dealers;
